import { Auth, API, Hub } from 'aws-amplify'
import axios from 'axios'
// import userflow from 'userflow.js'
import routes from './routes'
import * as models from './models'
import { store } from '../reduxStore'
import actionTypes from '../store/actions'
import { AVATAR_LOCALSTORAGE_KEY, DEFAULT_ENDPOINT, AUTH_ENDPOINT } from './constants'

// TODO: move to .env
const SYNC_USER_INTERVAL_MINUTES = process.env['REACT_APP_ENV'] === 'test' ? 1 : 10
const SYNC_USER_INTERVAL = 1000 * 60 * SYNC_USER_INTERVAL_MINUTES

const initialTableStatus = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'date',
  desc: true,
  filterTypes: [],
}

const initialInvoiceTableStatus = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'date',
  desc: true,
  filterTypes: [],
}

const initialBillTableStatus = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'date',
  desc: true,
  filterTypes: [],
}

export default class ServerApi {
  api = API
  // api = amplifyApiMock
  cachedEmail = null
  lastCheck = null

  constructor() {
    if (process.env['REACT_APP_ENV'] !== 'prod') {
      window.iceiceapi = this
    }
  }

  getDateFromDayspan(dayspan) {
    var result = new Date()
    result.setDate(result.getDate() - dayspan)
    return result
  }

  handleError(error) {
    // TODO: rewrite
    // const isDevEnd = process.env['REACT_APP_ENV'] !== 'prod' && process.env['REACT_APP_ENV'] !== 'test'

    // if (isDevEnd) {
    //   console.log("Error:", error)
    // }else{
    //   throw new Error(error)
    // }

    // store.dispatch({ type:  actionTypes.SHOWERRORNOTIFICATION })

    // setTimeout(() => {
    //   store.dispatch({ type:  actionTypes.HIDEERRORNOTIFICATION })
    // }, 3000);
    store.dispatch({ type: actionTypes.SETERRORSTATE, data: true })

    // TODO: add logging
  }

  async updateUser(body) {
    const res = await this.api.put(DEFAULT_ENDPOINT, routes.profile, {
      body: {
        ...body,
        avatarUrl: body.avatarUrl || process.env['REACT_APP_BRC_IMAGE_URL'] + '/png/cashflow_dashboard.png',
        updateDate: body.updateDate || new Date().toISOString(),
      },
    })

    let email
    if (this.cachedEmail === null) {
      email = await this.getUserEmail()
      this.cachedEmail = email
    } else {
      email = this.cachedEmail
    }

    const user = models.createUser({ ...res, email })

    return user
  }

  async createUser(data) {
    const body = {
      ...data,
      accessPeriodEnd: null,
      accountType: data.accountType,
    }

    // TODO: api.post dont return updated user, so call get
    await this.api.post(DEFAULT_ENDPOINT, routes.profile, { body })
    const res = await this.api.get(AUTH_ENDPOINT, routes.profile, { body })

    let email
    if (this.cachedEmail === null) {
      email = await this.getUserEmail()
      this.cachedEmail = email
    } else {
      email = this.cachedEmail
    }

    const user = models.createUser({ ...res, email })

    return user
  }

  async createBusinessDefault(data) {
    try {
      const body = {
        ...data,
      }
      const res = await this.api.post(DEFAULT_ENDPOINT, routes.createBusinessDefault, { body })
      return res
    } catch (error) {
      return error
    }
  }

  async getBusinessResources() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.businessResources, {})
    return res
  }

  async getUser() {
    let email = ''

    if (this.cachedEmail === null) {
      email = await this.getUserEmail()
      this.cachedEmail = email
    } else {
      email = this.cachedEmail
    }

    const user = await this.api.get(DEFAULT_ENDPOINT, routes.getUser, null)
    if (!!user?.business.length) {
      //NOTE: Default business ID for vault
      const index = user.business.findIndex(e => e.is_default === 'True' || e.is_default === true)
      store.dispatch({ type: actionTypes.SETDEFAULTBUSINESSID, data: user?.business[index].business_id })
    }
    return models.createUser({ ...user, email })
  }

  async getAuthedUser() {
    const profile = await this.getUser()
    store.dispatch({ type: actionTypes.COMMERCECODATDISCONNECTED })
    store.dispatch({ type: actionTypes.ACCOUNTCODATDISCONNECTED })
    if (profile) {
      store.dispatch({
        type: actionTypes.USERDATAFETCHED,
        data: profile,
      })
    }
    try {
      const businessInfo = await this.api.get(DEFAULT_ENDPOINT, routes.businessInfo, {
        queryStringParameters: {
          start: this.getDateFromDayspan(30).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: 6,
        },
      })

      if (businessInfo?.business_list.length === 0) {
        store.dispatch({ type: actionTypes.ACCOUNTINGCODATCONNECTED, data: false })
        store.dispatch({ type: actionTypes.COMMERCECODATCONNECTED, data: false })
      }

      store.dispatch({
        type: actionTypes.DASHBOARD_INFO_FETCHED,
        data: businessInfo,
      })

      if (businessInfo?.business_list[0]?.cod_business_id) {
        store.dispatch({ type: actionTypes.SETCOMPANYID, data: businessInfo?.business_list[0]?.cod_business_id })
        store.dispatch({ type: actionTypes.CODAT_INTEGRATED, data: true })
      } else {
        store.dispatch({ type: actionTypes.CODAT_INTEGRATED, data: false })
      }

      if (
        businessInfo?.business_list[0]?.Commerce[0]?.connection_id &&
        businessInfo?.business_list[0]?.Commerce[0]?.status?.trim().toUpperCase() === 'LINKED'
      ) {
        store.dispatch({ type: actionTypes.COMMERCECODATCONNECTED, data: true })
        store.dispatch({
          type: actionTypes.COMMERCECONNECTIONID,
          data: businessInfo.business_list[0]?.Commerce[0]?.connection_id,
        })
      }

      if (
        businessInfo?.business_list[0]?.Accounting[0]?.connection_id &&
        businessInfo?.business_list[0]?.Accounting[0]?.status &&
        businessInfo?.business_list[0]?.Accounting[0]?.status.trim().toUpperCase() === 'LINKED'
      ) {
        store.dispatch({ type: actionTypes.ACCOUNTINGCODATCONNECTED, data: true })
        store.dispatch({
          type: actionTypes.ACCOUNTINGCONNECTIONID,
          data: businessInfo.business_list[0]?.Accounting[0]?.connection_id,
        })
      }
    } catch (err) {
      throw new Error(err)
    }
    return Auth.currentAuthenticatedUser()
  }

  async getIsAdmin() {
    const isAdmin = await this.getAuthedUser().then(
      user => user?.getSignInUserSession()?.getIdToken().payload['custom:isAdmin'],
    )
    return isAdmin === 'TRUE'
  }

  async getUserInfo() {
    try {
      const userInfo = await this.getUser()

      return userInfo
    } catch (error) {
      console.error(error)
    }
  }

  async getBusinessData(businessId, refreshCreditScore) {
    try {
      const business = await this.api.get(DEFAULT_ENDPOINT, routes.getBusiness, {
        queryStringParameters: {
          business_id: businessId,
          refreshCreditScore: refreshCreditScore,
        },
      })

      return business?.details
    } catch (error) {
      console.error(error)
    }
  }

  async validateUserByInstaTouch(body) {
    try {
      return await this.api.post(DEFAULT_ENDPOINT, routes.instaTouch, { body })
    } catch (error) {
      //TODO: what to do?

      console.log(error)
    }

    throw new Error('InstaTouch Compare feiled')
  }

  async mobileIdVerificationInit(phone) {
    const body = { phoneNumber: phone }

    try {
      return await this.api.post(DEFAULT_ENDPOINT, routes.mobileIdInit, {
        body,
      })
    } catch (error) {
      throw new Error('Mobile verification id error')
    }
  }
  async mobileIdVerificationStart(sessionId) {
    const body = { sessionId: sessionId }
    return await this.api.post(AUTH_ENDPOINT, routes.mobileIdStart, { body })
  }

  async mobileIdVerificationStatus(sessionId) {
    const body = { sessionId }
    return await this.api.post(DEFAULT_ENDPOINT, routes.mobileIdStatus, {
      body,
    })
  }
  async kybMetric(body) {
    return await this.api.post(DEFAULT_ENDPOINT, routes.equifaxMetric, { body })
  }

  async getBlogFeed() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.feed, {})
    return res
  }
  async getBusinessCategories(search) {
    const body = { search }
    const res = await this.api.post(AUTH_ENDPOINT, routes.businessCategories, { body })
    return res
  }

  async getCountriesCodes(search) {
    const body = { search }
    const res = await this.api.post(AUTH_ENDPOINT, routes.countriesCodes, {
      body,
    })
    return res
  }

  async getStateCodes(search) {
    const body = { search }
    const res = await this.api.post(DEFAULT_ENDPOINT, routes.stateCodes, {
      body,
    })
    return res
  }

  async getStateName(data) {
    const { country = 'USA', state = '' } = data
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.stateName, {
      queryStringParameters: {
        country3: country,
        stateFilter: state,
      },
    })
    return res
  }

  async getCompanyTitles(search) {
    const body = { search }
    return await this.api.post(DEFAULT_ENDPOINT, routes.businessTitles, {
      body,
    })
  }

  async mobileIdVerificationCallback(sessionId) {
    const body = { sessionId }
    return await this.api.post(AUTH_ENDPOINT, routes.mobileIdCallback, {
      body,
    })
  }

  async searchBusinessByName(businessSearch, isPublic) {
    const body = {
      ...businessSearch,
    }
    const res = isPublic
      ? await this.api.post(AUTH_ENDPOINT, routes.publicSearch, { body })
      : await this.api.post(DEFAULT_ENDPOINT, routes.search, { body })

    if (Array.isArray(res.businessProfiles)) {
      return {
        models: res.businessProfiles.map(models.createBusiness),
        matched: res.matched,
      }
    }
    throw new Error('search business error')
  }
  async searchBusinessesByIds(ids, isPublic) {
    const body = {
      companyName: '',
      businessIds: ids || [],
      zipCode: '',
      miles: 0,
      returnLimit: 1,
      startFrom: 1,
    }

    const res = isPublic
      ? await this.api.post(AUTH_ENDPOINT, routes.publicSearch, { body })
      : await this.api.post(DEFAULT_ENDPOINT, routes.search, { body })
    if (Array.isArray(res.businessProfiles)) {
      return res.businessProfiles.map(models.createBusiness)
    }

    throw new Error('Public business search error')
  }

  // TODO: improve with usage direct url like /company/{id}
  async getBusinessById(id) {
    const body = {
      monitorCompanyIds: [id],
    }

    try {
      const res = await this.api.post(DEFAULT_ENDPOINT, routes.companyMonitor, {
        body,
      })
      if (Array.isArray(res)) {
        if (res.length === 0) {
          throw new Error('Nothing found')
        }
        if (res.length === 1) {
          return models.createBusiness(res[0])
        }
      }
      throw new Error('Bad server responce')
    } catch (error) {
      throw new Error('Error')
    }
  }

  async getBusinessesByIds(ids) {
    const promises = ids.map(id => this.getBusinessById(id))
    const models = await Promise.all(promises)
    return models
  }

  async signUp(email, password, firstName, lastName, mobileNumber) {
    const attributes = { email, 'custom:firstName': firstName, 'custom:lastName': lastName, phone_number: mobileNumber }
    return Auth.signUp({ username: email, password, attributes })
  }

  async signIn(email, password) {
    this.cachedEmail = email
    await Auth.signOut()
    return Auth.signIn(email, password)
  }

  async confirmSignUpEmail(email, code) {
    await Auth.confirmSignUp(email, code)
  }

  async confirmSignUpAndSignIn(email, code, password) {
    await Auth.signOut()
    await Auth.signIn(email, password)
  }

  async signOut() {
    this.cachedEmail = null
    return Auth.signOut()
  }

  async signOutOfAllDevices() {
    this.cachedEmail = null
    return Auth.signOut({ global: true })
  }


  async forgotPassword(email) {
    return Auth.forgotPassword(email)
  }

  async forgotPasswordSubmit(email, code, password) {
    return Auth.forgotPasswordSubmit(email, code, password)
  }

  async currentAuthenticatedUser() {
    return Auth.currentAuthenticatedUser()
  }

  async resendSignUp(email) {
    return Auth.resendSignUp(email)
  }

  async changePassword(oldPassword, newPassword) {
    const cognitoUser = await Auth.currentAuthenticatedUser()
    await Auth.changePassword(cognitoUser, oldPassword, newPassword)
  }

  async updateMyAccountAvatar(file) {
    // const fileName = `user-folder-asdasd1234sd/profileAvatar/${file.name}`
    // const result = await Storage.put(fileName, file, {
    //   progressCallback: (progress: any) => {
    //     // console.log(`Uploaded: ${progress.loaded}/${progress.total}`, progress)
    //   }
    // })

    // const key = 'user-folder-asdasd1234sd/profileAvatar/cat nana.jpg'
    // const signedURL = await Storage.get(key)

    // console.log(signedURL)

    return file.name
  }

  async saveMyAccountAvatarLocalStorage(data) {
    localStorage.setItem(AVATAR_LOCALSTORAGE_KEY, data)
  }

  async updateMyAccountProfile(data) {
    const { avatarUrl, ...restData } = data

    localStorage.setItem(AVATAR_LOCALSTORAGE_KEY, avatarUrl || '')

    return this.updateUser(restData)
  }

  async updateAvatar(file, route) {
    const url = process.env['REACT_APP_BACKEND_BASE_URL'] + route
    const token = async () => {
      const session = await Auth.currentSession()
      const idToken = session.getIdToken()
      return idToken.getJwtToken()
    }
    const jwtToken = await token()

    const resp = await axios.post(url, file, {
      headers: {
        Authorization: jwtToken,
        'Content-Type': 'multipart/form-data',
      },
    })
    return resp.data
  }

  async deleteAvatar(url, body) {
    return await this.api.del(DEFAULT_ENDPOINT, url, { body })
  }

  async deleteKeyPeople(businessKeyContactId) {
    return await this.api.del(DEFAULT_ENDPOINT, routes.deleteKeyPeople, {
      body: {
        businessKeyContactId: businessKeyContactId,
      },
    })
  }

  async getUserEmail() {
    const cognitoUser = await Auth.currentAuthenticatedUser()
    const attributes = await Auth.userAttributes(cognitoUser)
    const emailAttribute = attributes.find(attr => attr.Name === 'email')

    if (emailAttribute && emailAttribute.Value) {
      return emailAttribute.Value
    }

    throw new Error('no email in attributes')
  }

  async getDashboardData(companyId, dayspan, point = 6) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: true })
      store.dispatch({ type: actionTypes.LOADINGSALESDATA, data: true })
      store.dispatch({ type: actionTypes.CASHFLOWDATAFETCHED, data: [] })
      store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: [] })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getDashboardInfo, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point,
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.CASHFLOWDATAFETCHED,
          data: res.cash_flow,
        })
        store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: res.sale })
        store.dispatch({
          type: actionTypes.SUMMARYCASHFLOWDATA,
          data: {
            balance_sum: res.latest_balance,
            money_in_sum: res.money_in_sum,
            money_out_sum: res.money_out_sum,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.CASHFLOWDATAFETCHED, data: [] })
        store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: [] })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.CASHFLOWDATAFETCHED, data: [] })
      store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: [] })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: false })
      store.dispatch({ type: actionTypes.LOADINGSALESDATA, data: false })
    }
  }

  async getCashflowPopupData(companyId, dayspan, points = 15) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: points,
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.CASHFLOWCHARTDATAFETCHED,
          data: res.details,
        })
        store.dispatch({
          type: actionTypes.SUMMARYCASHFLOWDATA,
          data: {
            balance_sum: res.latest_balance,
            money_in_sum: res.money_in_sum,
            money_out_sum: res.money_out_sum,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.CASHFLOWCHARTDATAFETCHED, data: [] })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.CASHFLOWCHARTDATAFETCHED, data: [] })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: false })
    }
  }

  //TODO: This function will be depreacted
  async getCashflowData(companyId, dayspan, points = 6) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: points,
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.CASHFLOWDATAFETCHED,
          data: res.details,
        })
        store.dispatch({
          type: actionTypes.SUMMARYCASHFLOWDATA,
          data: {
            balance_sum: res.latest_balance,
            money_in_sum: res.money_in_sum,
            money_out_sum: res.money_out_sum,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.CASHFLOWDATAFETCHED, data: [] })
        this.handleError('Error response received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.CASHFLOWDATAFETCHED, data: [] })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWDATA, data: false })
    }
  }

  async getCashflowChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWCHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.CASHFLOWCHARTDATAFETCHED,
          data: res.details,
        })
        store.dispatch({
          type: actionTypes.SUMMARYCASHFLOWDATA,
          data: {
            balance_sum: res.latest_balance,
            money_in_sum: res.money_in_sum,
            money_out_sum: res.money_out_sum,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.CASHFLOWCHARTDATAFETCHED, data: [] })
        this.handleError('Error response received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.CASHFLOWCHARTDATAFETCHED, data: [] })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGCASHFLOWCHARTDATA, data: false })
    }
  }

  async getCashflowGraphData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.LOADINGCASHFLOWGRAPHDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowGraphData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.CASHFLOWGRAPHDATAFETCHED,
          data: res.details,
        })
        store.dispatch({
          type: actionTypes.SUMMARYCASHFLOWDATA,
          data: {
            balance_sum: res.latest_balance,
            money_in_sum: res.money_in_sum,
            money_out_sum: res.money_out_sum,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.CASHFLOWGRAPHDATAFETCHED, data: [] })
        this.handleError('Error response received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.CASHFLOWGRAPHDATAFETCHED, data: [] })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGCASHFLOWGRAPHDATA, data: false })
    }
  }

  async getCashflowTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    sortBy = 'cleared_on_date',
    desc = true,
    trxType = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGCASHFLOWTABLEDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          trxType,
        },
      })
      if (res.response_status === 200) {
        let records = res.details

        store.dispatch({
          type: actionTypes.CASHFLOWTABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records,
            pageNo,
            pageSize,
            sortBy,
            desc,
            trxType,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.CASHFLOWTABLEDATAFETCHED,
          data: initialTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.CASHFLOWTABLEDATAFETCHED,
        data: initialTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGCASHFLOWTABLEDATA,
        data: false,
      })
    }
  }

  //NOTE: will be deprecated
  async getPayablesData(companyId, dayspan, points = 15) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGPAYABLESDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: points,
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.PAYABLESDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {
            total_open_amount: res.total_open_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.PAYABLESDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {},
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.PAYABLESDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETPAYABLESSUMMARY,
        data: {},
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGPAYABLESDATA, data: false })
    }
  }

  async getPayablesChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGPAYABLESCHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.PAYABLESCHARTDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {
            total_open_amount: res.total_open_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.PAYABLESCHARTDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {},
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.PAYABLESCHARTDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETPAYABLESSUMMARY,
        data: {},
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGPAYABLESCHARTDATA, data: false })
    }
  }

  async getPayablesGraphData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.LOADINGPAYABLESGRAPHDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesGraphData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.PAYABLESGRAPHDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {
            total_open_amount: res.total_open_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.PAYABLESGRAPHDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETPAYABLESSUMMARY,
          data: {},
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.PAYABLESGRAPHDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETPAYABLESSUMMARY,
        data: {},
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGPAYABLESGRAPHDATA, data: false })
    }
  }

  async getPayablesTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    sortBy = 'issue_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGPAYABLESTABLEDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.PAYABLESTABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.PAYABLESTABLEDATAFETCHED,
          data: { ...initialTableStatus, sortBy: 'issue_date' },
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.PAYABLESTABLEDATAFETCHED,
        data: { ...initialTableStatus, sortBy: 'issue_date' },
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGPAYABLESTABLEDATA,
        data: false,
      })
    }
  }

  async getPaidBillsTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 5,
    sortBy = 'issue_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGPAIDBILLSDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.PAIDBILLSDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.PAIDBILLSDATAFETCHED,
          data: initialBillTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.PAIDINVOICESDATAFETCHED,
        data: initialBillTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGPAIDBILLSDATA,
        data: false,
      })
    }
  }

  async getUnpaidBillsTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 5,
    sortBy = 'issue_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGUNPAIDBILLSDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.UNPAIDBILLSDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.UNPAIDBILLSDATAFETCHED,
          data: initialBillTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.UNPAIDBILLSDATAFETCHED,
        data: initialBillTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGUNPAIDBILLSDATA,
        data: false,
      })
    }
  }

  async getReceivablesData(companyId, dayspan, points = 15) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGRECEIVABLESDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: points,
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.RECEIVABLESDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {
            total_submitted_amount: res.total_submitted_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.RECEIVABLESDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {},
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.RECEIVABLESDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETRECEIVABLESSUMMARY,
        data: {},
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGRECEIVABLESDATA, data: false })
    }
  }

  async getReceivablesChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGRECEIVABLESCHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.RECEIVABLESCHARTDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {
            total_submitted_amount: res.total_submitted_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.RECEIVABLESCHARTDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {},
        })
        // this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.RECEIVABLESCHARTDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETRECEIVABLESSUMMARY,
        data: {},
      })
      // this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGRECEIVABLESCHARTDATA, data: false })
    }
  }

  async getReceivablesGraphData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.LOADINGRECEIVABLESGRAPHDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesGraphData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        //Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        store.dispatch({
          type: actionTypes.RECEIVABLESGRAPHDATAFETCHED,
          data: res.details,
        })

        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {
            total_submitted_amount: res.total_submitted_amount,
            total_paid_amount: res.total_paid_amount,
          },
        })
      } else {
        store.dispatch({ type: actionTypes.RECEIVABLESGRAPHDATAFETCHED, data: [] })
        store.dispatch({
          type: actionTypes.SETRECEIVABLESSUMMARY,
          data: {},
        })
        // this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.RECEIVABLESGRAPHDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SETRECEIVABLESSUMMARY,
        data: {},
      })
      // this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGRECEIVABLESGRAPHDATA, data: false })
    }
  }

  async getReceivablesTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    sortBy = 'due_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGRECEIVABLESTABLEDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.RECEIVABLESTABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.RECEIVABLESTABLEDATAFETCHED,
          data: initialTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.RECEIVABLESTABLEDATAFETCHED,
        data: initialTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGRECEIVABLESTABLEDATA,
        data: false,
      })
    }
  }

  async getPaidInvoicesTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 5,
    sortBy = 'due_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGPAIDINVOICESDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.PAIDINVOICESDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.PAIDINVOICESDATAFETCHED,
          data: initialInvoiceTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.PAIDINVOICESDATAFETCHED,
        data: initialInvoiceTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGPAIDINVOICESDATA,
        data: false,
      })
    }
  }

  async getUnpaidInvoicesTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 5,
    sortBy = 'due_date',
    desc = true,
    status = [],
  ) {
    try {
      store.dispatch({
        type: actionTypes.SETLOADINGUNPAIDINVOICESDATA,
        data: true,
      })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivablesTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          status,
        },
      })
      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.UNPAIDINVOICESDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            sortBy,
            desc,
            status,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({
          type: actionTypes.UNPAIDINVOICESDATAFETCHED,
          data: initialInvoiceTableStatus,
        })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({
        type: actionTypes.UNPAIDINVOICESDATAFETCHED,
        data: initialInvoiceTableStatus,
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({
        type: actionTypes.SETLOADINGUNPAIDINVOICESDATA,
        data: false,
      })
    }
  }

  // TODO: currently BE team has expose only /info api for getting sales data with also include other dashboard information as well
  // once we have sperate api which provides only sales data update this with new api
  async getSalesData(companyId, dayspan, point = 6) {
    try {
      store.dispatch({ type: actionTypes.LOADINGSALESDATA, data: true })
      store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: {} })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getDashboardInfo, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point,
        },
      })
      if (res.response_status === 200) {
        store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: res.sale })
      } else {
        store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: {} })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SALESDATAFETCHED, data: {} })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGSALESDATA, data: false })
    }
  }

  async getSalesTransactionChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.LOADINGSALESTRANSACTIONCHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesTransactionChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.SETSALESTRANSACTIONCHARTDATA,
          data: res.details,
        })
      } else {
        store.dispatch({ type: actionTypes.SETSALESTRANSACTIONCHARTDATA, data: [] })
        // this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SETSALESTRANSACTIONCHARTDATA, data: [] })
      // this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGSALESTRANSACTIONCHARTDATA, data: false })
    }
  }

  async getSalesChartData(companyId, dayspan) {
    try {
      const salesTransactionResponse = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesTransactions, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: 6,
        },
      })
      if (salesTransactionResponse.response_status === 200) {
        store.dispatch({
          type: actionTypes.SALESTRANSACTIONDATAFETCHED,
          data: salesTransactionResponse.details,
        })
        const salesVolumeResponse = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesVolume, {
          queryStringParameters: {
            companyId: companyId,
            start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
            end: new Date().toISOString().split('T')[0],
            point: 6,
          },
        })
        if (salesVolumeResponse.response_status === 200) {
          store.dispatch({
            type: actionTypes.SALESVOLUMEDATAFETCHED,
            data: salesVolumeResponse.details,
          })
          const salesDisputesResponse = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesDisputes, {
            queryStringParameters: {
              companyId: companyId,
              start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
              end: new Date().toISOString().split('T')[0],
              point: 6,
            },
          })
          if (salesDisputesResponse.response_status === 200) {
            store.dispatch({
              type: actionTypes.SALESDISPUTESDATAFETCHED,
              // eslint-disable-next-line no-use-before-define
              data: salesDisputesResponse?.details,
            })
          } else {
            store.dispatch({
              type: actionTypes.SALESDISPUTESDATAFETCHED,
              data: [],
            })
            this.handleError('Error responce received from the API', salesDisputesResponse)
          }
        } else {
          store.dispatch({
            type: actionTypes.SALESVOLUMEDATAFETCHED,
            data: [],
          })
          this.handleError('Error responce received from the API', salesVolumeResponse)
        }
      } else {
        store.dispatch({
          type: actionTypes.SALESTRANSACTIONDATAFETCHED,
          data: [],
        })
        this.handleError('Error responce received from the API', salesTransactionResponse)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SALESDISPUTESDATAFETCHED, data: [] })
      store.dispatch({ type: actionTypes.SALESCUSTOMERDATAFETCHED, data: [] })
      store.dispatch({ type: actionTypes.SALESVOLUMEDATAFETCHED, data: [] })
      store.dispatch({
        type: actionTypes.SALESTRANSACTIONDATAFETCHED,
        data: [],
      })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGSALESCHARTDATA, data: false })
    }
  }

  async getSalesVolumeChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGSALESVOLUMECHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesVolumeChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.SETSALESVOLUMECHARTDATA,
          data: res.details,
        })
      } else {
        store.dispatch({ type: actionTypes.SETSALESVOLUMECHARTDATA, data: [] })
        // this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SETSALESVOLUMECHARTDATA, data: [] })
      // this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGSALESVOLUMECHARTDATA, data: false })
    }
  }

  async getSalesDisputeChartData(companyId, dayspan) {
    try {
      store.dispatch({ type: actionTypes.SETLOADINGSALESDISPUTECHARTDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getSalesDisputeChartData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      })
      if (res.response_status === 200) {
        store.dispatch({
          type: actionTypes.SETSALESDISPUTECHARTDATA,
          data: res.details,
        })
      } else {
        store.dispatch({ type: actionTypes.SETSALESDISPUTECHARTDATA, data: [] })
        // this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SETSALESDISPUTECHARTDATA, data: [] })
      // this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.SETLOADINGSALESDISPUTECHARTDATA, data: false })
    }
  }

  async getTransactionTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    paymentMethod = [],
    paymentStatus = [],
    sortBy = 'due_date',
    desc = true,
  ) {
    try {
      store.dispatch({ type: actionTypes.LOADINGTRANSACTIONTABLEDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getTransactionDetailsTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          paymentMethod,
          paymentStatus,
        },
      })

      if (res.response_status === 200) {
        // Todo: below line is just a hack for now. Once we have Codat Company integration, we need remove this
        // store.dispatch({ type: actionTypes.CODATCONNECTED })
        let { details } = res

        store.dispatch({
          type: actionTypes.SALESTRANSACTIONTABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            paymentMethod,
            paymentStatus,
            sortBy,
            desc,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({ type: actionTypes.SALESTRANSACTIONTABLEDATAFETCHED, data: null })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SALESTRANSACTIONTABLEDATAFETCHED, data: null })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGTRANSACTIONTABLEDATA, data: false })
    }
  }

  async getSaleVolumneTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    paymentMethod = [],
    paymentStatus = [],
    sortBy = 'created_date',
    desc = true,
  ) {
    try {
      // TODO: sort_by
      store.dispatch({ type: actionTypes.LOADINGSALEDISPUTETABLEDATA, data: true })

      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getSaleVolumeTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          payment_method: paymentMethod,
          // Backend do not support payment status filter
          // paymentStatus,
        },
      })

      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.SALESVOLUMETABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            paymentMethod,
            paymentStatus,
            sortBy,
            desc,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({ type: actionTypes.SALESVOLUMETABLEDATAFETCHED, data: null })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SALESVOLUMETABLEDATAFETCHED, data: null })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGSALEVOLUMETABLEDATA, data: false })
    }
  }

  async getSaleDisputeTableData(
    companyId,
    dayspan,
    pageNo = 1,
    pageSize = 20,
    paymentStatus = [],
    sortBy = 'total_amount',
    desc = true,
  ) {
    try {
      // TODO: sort_by
      store.dispatch({ type: actionTypes.LOADINGDISPUTETABLEDATA, data: true })
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getDisputeTableData, {
        queryStringParameters: {
          companyId: companyId,
          start: this.getDateFromDayspan(dayspan).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          pageNo,
          pageSize,
          sortBy: desc ? '-' + sortBy : sortBy,
          paymentStatus,
        },
      })

      if (res.response_status === 200) {
        let { details } = res

        store.dispatch({
          type: actionTypes.SALESDISPUTETABLEDATAFETCHED,
          data: {
            totalCount: res.rec_count,
            pageCount: res.page_count,
            records: details,
            pageNo,
            pageSize,
            paymentStatus,
            sortBy,
            desc,
            filterTypes: res.filterTypes || [],
          },
        })
      } else {
        store.dispatch({ type: actionTypes.SALESDISPUTETABLEDATAFETCHED, data: null })
        this.handleError('Error responce received from the API', res)
      }
    } catch (error) {
      store.dispatch({ type: actionTypes.SALESDISPUTETABLEDATAFETCHED, data: null })
      this.handleError('Error from API', error)
    } finally {
      store.dispatch({ type: actionTypes.LOADINGDISPUTETABLEDATA, data: false })
    }
  }

  onUserStateChange(callback) {
    const unsubscribeUser = Hub.listen('user', ({ payload }) => {
      const { data } = payload
      callback(data)
    })

    return () => {
      unsubscribeUser()
    }
  }

  // TODO: improve / cleanup
  onAuthedUserStateChange(callback) {
    const unsubscribeAuth = Hub.listen('auth', async obj => {
      const { payload } = obj
      const { event, data } = payload

      switch (event) {
        case 'signIn':
          // const user = await getFakeUser()
          callback(data)
          break
        case 'signOut':
          callback(null)
          break
        default:
          return
        // case 'customOAuthState':
        //   setState({ customState: data });
      }
    })

    return () => {
      unsubscribeAuth()
    }
  }

  async validateKYC() {
    await delay()
    await delay()
    this.updateUser({ kycValidated: new Date() })
  }

  async markExplanatoryPageShowed() {
    await delay()
    this.updateUser({ explanatoryPageBeenShowed: true })
  }

  async createSubscription(paymentMethodId, priceId, promotionId) {
    // TODO: ask back-end to remove body
    const userRequestBody = { service: 'stripe' }
    const stripeUser = await this.api.put(AUTH_ENDPOINT, routes.stripeUser, {
      body: userRequestBody,
    })
    // TODO: ask back-end to rename
    const customerId = stripeUser.stripeId
    const subscriptionType = models.getAccountTypeByPriceId(priceId)
    const body = {
      customerId,
      paymentMethodId,
      priceId,
      promotionId,
      subscriptionType,
    }

    const subscriptionState = await this.getSubscriptionState()
    const upgrade = subscriptionState.subscriptions.filter(item => item.status === 'active').length > 0

    if (upgrade) {
      await this.cancelSubscription()
    }

    const res = await this.api.post(AUTH_ENDPOINT, routes.subscription, {
      body,
    })

    if (res.operation && res.operation === 'successful') {
      // userflow.track('subscription_active', {
      //   paymentMethodId: paymentMethodId,
      //   subscriptionType,
      //   date: new Date().toISOString(),
      //   priceId: priceId,
      //   promotionId: promotionId,
      // })
      window.StonlyWidget('track', 'subscription_active')
      return await this.getUser()
    } else {
      throw new Error('Error')
    }
  }

  async storeStripeAuth(body) {
    return await this.api.post(DEFAULT_ENDPOINT, routes.storeStripeAuth, { body })
  }

  async ekataVerification(data) {
    const { result, error_message } = await this.api.post(AUTH_ENDPOINT, routes.ekataVerification, { body: data })

    if (result === 'ok') {
      return result
    } else {
      throw new Error(error_message)
    }
  }

  async getReviewRequestsList(data) {
    try {
      const year = new Date(data.date).getFullYear()
      const month =
        new Date(data.date).getMonth() + 1 < 10
          ? `0${new Date(data.date).getMonth() + 1}`
          : new Date(data.date).getMonth() + 1
      const day =
        new Date(data.date).getDate() < 10 ? `0${new Date(data.date).getDate()}` : new Date(data.date).getDate()
      const date = `${year}-${month}-${day}`
      return await this.api.post(DEFAULT_ENDPOINT, routes.reviewRequestsList, {
        body: { ...data, date },
      })
    } catch (error) {
      throw new Error('Error')
    }
  }

  async getReviewRequestItem(id) {
    try {
      return await this.api.get(DEFAULT_ENDPOINT, `${routes.reviewRequestItem}/${id}`, null)
    } catch (error) {
      throw new Error('Error')
    }
  }

  async approveReviewRequest(data) {
    try {
      return await this.api.post(DEFAULT_ENDPOINT, routes.reviewRequestApprove, {
        body: data,
      })
    } catch (error) {
      throw new Error('Error')
    }
  }

  async declineReviewRequest(data) {
    try {
      return await this.api.post(DEFAULT_ENDPOINT, routes.reviewRequestDecline, {
        body: data,
      })
    } catch (error) {
      throw new Error('Error')
    }
  }

  async getSubscriptionState() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.subscription, null)

      if (res.operation) {
        if (res.operation === 'successful') {
          return models.createSubscriptionState(res)
        } else {
          throw new Error(res.message)
        }
      } else {
        throw new Error('Server error')
      }
    } catch (error) {
      throw new Error('Error')
    }
  }

  async cancelSubscription() {
    try {
      const res = await this.api.del(DEFAULT_ENDPOINT, routes.subscription, null)

      if (res.operation) {
        if (res.operation !== 'success') {
          throw new Error(res.message)
        }
      } else {
        throw new Error('Server error')
      }

      // const body: Partial<models.User> = { accountType: 'trial' }
      // await this.api.put(DEFAULT_ENDPOINT, routes.profile, { body })
      // return this.updateUser(body)
      return this.getUser()
    } catch (error) {
      throw new Error('Error')
    }
  }

  async getStripeUser() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.stripeUser, null)
    return res
  }

  async getPaymentMethod() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.stripeUser, null)

    if (res?.payment_method) {
      return models.createPaymentMethod(res.payment_method)
    }

    return null
  }

  async getProducts() {
    // TODO: load products
    // const res = await this.api.get(DEFAULT_ENDPOINT, routes.stripeProducts, null)
  }

  async getPromotionCode(promotionCode) {
    const body = { promotionCode }
    const res = await this.api.post(AUTH_ENDPOINT, routes.stripePromotions, {
      body,
    })

    const codes = res.data.map(models.createStripePromotionCode)
    const activeCodes = codes.filter(code => code.active !== null)
    const [code] = activeCodes
    if (code) return models.createStripePromotionCode(code)
    return null
  }

  async updateMyBusinessKeyPeople(body, callBack) {
    callBack({ isOpen: false, type: 'success', message: '' })
    try {
      return await this.api.put(
        DEFAULT_ENDPOINT,
        routes.userBusinessKeyPeople,
        {
          body,
        },
        callBack &&
        callBack({
          isOpen: true,
          type: 'success',
          message: 'Successfully updated management information',
        }),
      )
    } catch (err) {
      return (
        callBack &&
        callBack({
          isOpen: true,
          type: 'error',
          message: 'Something went wrong. Please try again.',
        })
      )
    }
  }

  async updateMyBusinessInfo(body) {
    return await this.api.put(DEFAULT_ENDPOINT, routes.userBusinessInfo, {
      body,
    })
  }

  async updateMyBusinessProfile(body) {
    return await this.api.put(DEFAULT_ENDPOINT, routes.userBusinessProfile, {
      body,
    })
  }

  async kycValidate(phone) {
    await delay()
    await delay()

    if (phone === '(111)111-1111') {
      const kycValidated = new Date()

      await this.updateUser({ kycValidated })

      return this.getUser()
    }

    if (phone === '(222)222-2222') {
      return null
    }

    return Promise.reject('Error')
  }

  async getMonitorCompanies() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.userMonitor, null)
      if (res === null) return []

      if (res.companies && Array.isArray(res.companies)) {
        return res.companies
      }
    } catch (err) {
      throw err
    }
  }

  async updateMonitorIds(currentIds, model) {
    try {
      const id = model.ext_id
      const addIds = currentIds.includes(id) ? [] : [id]
      const removeIds = currentIds.includes(id) ? [id] : []
      const body = { addIds, removeIds }
      const res = await this.api.post(DEFAULT_ENDPOINT, routes.userMonitor, {
        body,
      })
      return res.details
    } catch (err) {
      return err
    }
  }

  // TODO: add check extIds.length === res.businessProfiles.length
  // because can be like https://markaaz.atlassian.net/browse/MKZ-566
  async getMonitoredCompanies(extIds) {
    const body = { extIds }

    try {
      const res = await this.api.post(DEFAULT_ENDPOINT, routes.search, { body })
      return res.businessProfiles.map(models.createBusiness)
    } catch (e) {
      throw new Error('Error')
    }
  }

  async getBuisenessByExtIds(extId) {
    if (extId === null || extId === undefined) return null
    const [business] = await this.getMonitoredCompanies([extId])
    return business || null
  }

  async getBuisenessesByExtIds(extIds) {
    if (!extIds || !extIds.length) return null
    const businesses = await this.getMonitoredCompanies(extIds)
    return businesses
  }

  async getUsersBusinessByExtId(extId) {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.userBusinessIds, null)

    if (Array.isArray(res.companies)) {
      if (res.companies.length === 0) {
        return null
      }
      const business = res.companies.find(company => company.ext_id === extId)
      return business || null
    }

    throw new Error('Error when try to get users business')
  }

  checkUserData() {
    const subscribable = {
      subscribe: (onSucces, onError) => {
        const intervalId = setInterval(() => {
          const promise = this.getUser()
          promise.then(onSucces).catch(onError)
        }, SYNC_USER_INTERVAL)

        return () => {
          clearInterval(intervalId)
        }
      },
    }

    return subscribable
  }

  pushMessage(text, actionUrl, customId) {
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    const id = customId || Math.random().toString()
    const message = { id, text, actionUrl }
    const nextMessages = [...messages, message]
    const data = JSON.stringify(nextMessages, null, 2)

    localStorage.setItem('messages', data)

    Hub.dispatch('messages', {
      data: nextMessages,
      event: 'default event 12324',
    })
  }

  getMessages() {
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    Hub.dispatch('messages', { data: messages, event: 'default event 12324' })
  }

  hasMessage(id) {
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    const index = messages.findIndex(message => message.id === id)
    return index !== -1
  }

  removeMessage(id) {
    // TODO: fix forced type
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    const nextMessages = messages.filter(item => item.id !== id)

    const data = JSON.stringify(nextMessages, null, 2)

    localStorage.setItem('messages', data)

    Hub.dispatch('messages', {
      data: nextMessages,
      event: 'default event 12324',
    })
  }

  markAsReadMessage(id) {
    const messages = JSON.parse(localStorage.getItem('messages') || '[]')
    const nextMessages = messages.map(item => {
      if (item.id !== id) return item
      return { ...item, read: true }
    })

    const data = JSON.stringify(nextMessages, null, 2)

    localStorage.setItem('messages', data)

    Hub.dispatch('messages', {
      data: nextMessages,
      event: 'default event 12324',
    })
  }

  onMessages(onSucces, onError) {
    const subscribable = {
      subscribe: (onSucces, onError) => {
        const callback = event => {
          onSucces(event.payload.data)
        }

        Hub.listen('messages', callback)

        return () => {
          Hub.remove('messages', callback)
        }
      },
    }

    return subscribable.subscribe(onSucces, onError)
  }

  async checkKYBCallback2(kybSessionId) {
    const res = await this.mobileIdVerificationStatus(kybSessionId)

    switch (res.status) {
      case 'PENDING':
      case 'FAILED':
      case 'SUCCESS':
      case 'EXPIRED':
        return res.status
      default: {
        throw new Error(`Incorrect KYB1 session status, should be PENDING | FAILED | SUCCESS`)
      }
    }
  }

  async getUsersBusinesses() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.userBusinessIds, null)

      if (Array.isArray(res.companies)) {
        if (res.companies.length === 0) {
          return null
        }
        return res.companies
      }
    } catch (err) {
      throw err
    }
  }

  async getBusinessDetails(businessId, source) {
    try {
      const queryStringParameters = {};
      if (businessId) {
        queryStringParameters.businessId = businessId;
      }
      if (source) {
        queryStringParameters.source = source;
      }
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.businessDetails, {
        queryStringParameters
      })

      if (res) {
        return res
      }
    } catch (err) {
      throw err
    }
  }

    async updateBusinessAddressLatitudeAndLongitude(mkzBusinessId, addressLat, addressLon) {
    try {
      const res = await this.api.patch(DEFAULT_ENDPOINT, routes.updateBusinessAddressLatitudeAndLongitude, {
        body: {
          mkzBusinessId: mkzBusinessId,
          addressLat: addressLat,
          addressLon: addressLon,
        },
      })

      if (res) {
        return res
      }
    } catch (err) {
    }
  }

  async getBusinessProfile() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.getBusinessProfile, null)
    if (res) {
      return res
    }
    throw new Error('Error when try to get users business ids')
  }

  async paymentAbandonedOnClose() {
    const url = process.env['REACT_APP_BACKEND_BASE_URL'] + routes.userAbandonedPayment
    const token = async () => {
      const session = await Auth.currentSession()
      const idToken = session.getIdToken()
      return idToken.getJwtToken()
    }
    const jwtToken = await token()
    const formData = new FormData()
    formData.append('authorization', jwtToken)
    return await navigator.sendBeacon(url, formData)
  }

  async doKYB1(body) {
    const res = await API.post(DEFAULT_ENDPOINT, routes.equifaxCashflowInsights, { body })

    if (res.status === 'SUCCESS') {
      const result = {
        token: res.token,
        transactionId: res.transactionId,
        accountId: res.accountId,
        sessionId: res.sessionId,
      }
      return result
    }

    if (res.status === 'FAILED') {
      throw new Error(res.error)
    }

    throw new Error('Server error')
  }

  async doKYB2(body) {
    const res = await API.post(DEFAULT_ENDPOINT, routes.equifaxPaymentInsights, {
      body,
    })

    if (res.status === 'SUCCESS') {
      const result = {
        token: res.token,
        transactionId: res.transactionId,
        accountId: res.accountId,
        sessionId: res.sessionId,
      }

      return result
    }

    if (res.status === 'FAILED') {
      throw new Error(res.error)
    }

    throw new Error('Server error')
  }

  async getPaymentInsightsCredentials() {
    return new Promise(res => {
      setTimeout(res, 2000)
    })
  }

  async toggleDisplayField(body) {
    try {
      return await this.api.put(DEFAULT_ENDPOINT, routes.displayField, { body })
    } catch (e) {
      throw new Error('Error')
    }
  }

  // businessId should be companyId as request change
  async connectApp(companyName, companyId) {
    try {
      return await API.post(DEFAULT_ENDPOINT, routes.connectApp, {
        body: {
          business_id: companyId || 1,
          business_name: companyName,
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async getCodatConnectUserInfo() {
    try {
      return await this.api.get(DEFAULT_ENDPOINT, routes.codatUserInfo)
    } catch (error) {
      throw new Error(error)
    }
  }

  async getUserAlerts() {
    try {
      return await API.get(DEFAULT_ENDPOINT, routes.getAlerts, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async disconnectApp(companyId, connectionId) {
    try {
      return await API.post(DEFAULT_ENDPOINT, routes.disconnectApp, {
        body: {
          company_id: companyId,
          connection_id: connectionId,
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async markAsReadAlerts(alerts) {
    try {
      return await API.patch(DEFAULT_ENDPOINT, routes.getAlerts, { body: { alerts } })
    } catch (error) {
      throw new Error(error)
    }
  }

  async getDashboardInfo(data = {}) {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.businessInfo, {
        queryStringParameters: {
          start: this.getDateFromDayspan(30).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
          point: 6,
        },
      })
      store.dispatch({
        type: actionTypes.DASHBOARD_INFO_FETCHED,
        data: res,
      })
      return res
    } catch (_e) {
      throw new Error(_e)
    }
  }

  // Get Cashflow and Sale Tile - Tables data

  async getCashflowTrxTypeFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getCashflowTrxType)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.CASHFLOW_TRX_TYPES_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      } else {
        throw new Error()
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getPayableBillStatusFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getPayableBillStatus)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.PAYABLE_BILL_STATUS_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      } else {
        throw new Error()
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getBillSummary(companyId, days) {
    try {
      const billSummary = await this.api.get(DEFAULT_ENDPOINT, routes.getPayableBillSummary, {
        queryStringParameters: {
          companyId: companyId,
          days: days,
        },
      })
      if (billSummary?.response_status === 200) {
        store.dispatch({
          type: actionTypes.PAYABLE_BILL_STATUS_FILTERS_FETCHED,
          data: billSummary?.details,
        })
        return billSummary?.details
      } else {
        throw new Error()
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getReceivableInvoiceStatusFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivableInvoiceStatus)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.RECEIVABLE_INVOICE_STATUS_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      } else {
        throw new Error()
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getInvoiceSummary(companyId, days) {
    try {
      const invoiceSummary = await this.api.get(DEFAULT_ENDPOINT, routes.getReceivableInvoiceSummary, {
        queryStringParameters: {
          companyId: companyId,
          days: days,
        },
      })
      if (invoiceSummary?.response_status === 200) {
        store.dispatch({
          type: actionTypes.RECEIVABLE_INVOICE_TABLE_STATUS_FETCHED,
          data: invoiceSummary?.details,
        })
        return invoiceSummary?.details
      } else {
        throw new Error()
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  async getDisputePaymentStatusFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getDisputePaymentStatus)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.DISPUTE_PAYMENT_STATUS_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      } else {
        throw new Error()
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getTransactionPaymentMethodFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getTransactionPaymentMethod)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.TRANSACTION_PAYMENT_METHOD_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getTransactionPaymentStatusFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getTransactionPaymentStatus)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.TRANSACTION_PAYMENT_STATUS_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getTransactionTypeFilter() {
    try {
      const res = await this.api.get(DEFAULT_ENDPOINT, routes.getTransactionType)
      if (res?.response_status === 200) {
        store.dispatch({
          type: actionTypes.TRANSACTION_TYPES_FILTERS_FETCHED,
          data: res?.filterTypes,
        })
        return res?.filterTypes
      }
    } catch (_e) {
      throw new Error(_e)
    }
  }

  async getNavCTADetails(body) {
    try {
      return await API.post(DEFAULT_ENDPOINT, routes.getNavCTADetails, {
        body,
      })
    } catch (error) {
      return new Error(error)
    }
  }

  async getNavToken(body) {
    try {
      return await API.post(DEFAULT_ENDPOINT, routes.getNavToken, {
        body,
      })
    } catch (error) {
      return new Error(error)
    }
  }

  async getStripePaymentList() {
    try {
      return await API.get(DEFAULT_ENDPOINT, routes.stripePaymentMethods)
    } catch (error) {
      return error.response
    }
  }

  async addNewStripePayment(body) {
    try {
      return await API.post(DEFAULT_ENDPOINT, routes.stripePaymentMethods, {
        body,
      })
    } catch (error) {
      return error.response
    }
  }
  async makeDefaultStripePayment(body) {
    try {
      return await API.patch(DEFAULT_ENDPOINT, routes.stripePaymentMethods, {
        body,
      })
    } catch (error) {
      return error.response
    }
  }

  async deleteStripePayment(body) {
    try {
      return await API.del(DEFAULT_ENDPOINT, routes.stripePaymentMethods, {
        body,
      })
    } catch (error) {
      return error.response
    }
  }

  async getNavAuthToken() {
    return await this.api.post(DEFAULT_ENDPOINT, '/integration/nav/user-token', {
      headers: {
        'Content-Type': 'text/plain',
      },
    })
  }

  async createNavUser(body) {
    return await this.api.post(DEFAULT_ENDPOINT, '/integration/nav/user', { body })
  }

  async getBusinessPartnerSolutions() {
    const res = await this.api.get(DEFAULT_ENDPOINT, routes.businessPartnerSolutions, null)
    if (res) {
      return res
    }
    throw new Error('Error when try to get users business ids')
  }

  async businessSolutionsAudit(logo_id) {
    const body = { logo_id: logo_id }
    return await this.api.post(DEFAULT_ENDPOINT, routes.businessPartnerSolutionsAudits, { body })
  }
}

// // TODO: for mock purpose
const delay = () => {
  return new Promise(res => {
    setTimeout(res, Math.random() * 1000)
  })
}
